module.exports = __webpack_public_path__ + "static/media/Twitter.9900d3f6.svg";